<template>
  <div class="step1">
    <!-- <div class="city_plaza_rest_info">
      リニューアルに伴いシティプラザ店は4月1日(土)〜7月初旬(予定)の期間休業いたします。<br />
      お客様には大変ご迷惑をお掛け致しますが、何卒ご理解いただきますようお願い申し上げます。
    </div> -->
    <div class="about-smartshop-container">
      <a
        href="https://g-spoon.co.jp/news/smart-shop-open/"
        class="about-smartshop-text"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>スマートショップとは？</span>
      </a>
    </div>
    <div v-for="(shop, index) in integratedShops" :key="index" class="inputList" v-show="!isItemsLoading">
      <div class="div inputList__div" @click="bgColor(index)">
        <p>
          <input
            type="radio"
            name="shopName"
            :value="shop.title.rendered"
            @click="getStore(shop)"
            :id="shop.title.rendered"
            :checked="radioResult !== '' ? radioResult === shop.title.rendered : index == 0"
          />
        </p>
        <label :for="shop.title.rendered">
          <span class="span1"
            >{{ shop.title.rendered }} <span v-show="shop.id === 204">（文化センター通り）</span
            ><span v-show="shop.id === 206">（六ツ門交差点）</span
            ><span v-show="shop.id === 208">（博多駅マイング名店街店）</span>
            <span v-show="getSmartShopEnabled(shop.title.rendered)" class="smartshop-badge">スマートショップ</span>
          </span>

          <br /><span class="span2">電話番号：{{ shop.acf.tel }}</span>
          <div v-show="shop.id === 210" style="font-size: 11px; color: red">※焼菓子のみのお取り扱いとなります。</div>
        </label>
      </div>
      <button
        type="button"
        class="btn mapBtn"
        @click="
          showMap()
          googleMap(index)
        "
        :id="index"
      >
        <i class="fas fa-map-marked-alt"></i>地図を見る
      </button>
    </div>

    <div class="step1__modal" id="step1__modal">
      <div class="step1__modal--white">
        <p class="stopButton" id="stopButtonMap" @click="hideMap"><i class="fas fa-times"></i></p>
        <div
          v-for="(shop, index) in reserveShops"
          :key="index"
          :id="['map' + index]"
          v-html="shop.acf.google_map"
          class="googleMap"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step1',
  props: ['buttonText', 'step', 'shops', 'reservation', 'reserveShops', 'radioResult', 'isItemsLoading'],
  computed: {
    integratedShops() {
      return this.shops.map(shop => {
        return {
          ...shop,
          acf: {
            ...shop.acf,
            week:
              this.reserveShops.find(reserveShop => reserveShop.title.rendered === shop.title.rendered)?.acf?.week ??
              [],
            tel: this.reserveShops.find(reserveShop => reserveShop.title.rendered === shop.title.rendered)?.acf?.tel
          }
        }
      })
    }
  },
  mounted() {
    // console.log('store', !this.reservation.store)
    // if (!this.reservation.store) this.getStore(this.integratedShops[0])
  },
  updated() {
    if (!this.reservation.store) {
      this.getStore(this.integratedShops[0])
      this.setRadioResult(this.integratedShops?.[0]?.title?.rendered ?? '')
    }

    // this.getStore(this.integratedShops[0])
    //headerのボタンの表示
    const pageHeaderCartBtn = document.getElementById('pageHeaderCartBtn')
    pageHeaderCartBtn.style.display = 'none'
    const pageHeaderCartBtn_first = document.getElementById('pageHeaderCartBtn_first')
    pageHeaderCartBtn_first.style.display = 'block'
    //inputの背景色変化！（クラスの付与）
    // let inputList = document.getElementsByClassName('inputList')
    // inputList[0].classList.add('bg_current')
  },
  methods: {
    setRadioResult: function(shopName) {
      this.$emit('setRadioResult', shopName)
    },
    disableCityPlaza: function(shops) {
      return shops.filter(shop => shop.title.rendered !== 'シティプラザ店')
    },
    getSmartShopEnabled: function(shopName) {
      return this.reserveShops.find(reserveShop => reserveShop.title.rendered === shopName)?.acf?.smartshop
    },
    getStore: function(shop) {
      this.reservation.store = shop
      this.setRadioResult(shop?.title?.rendered ?? '')
    },
    showMap: function() {
      let modalStep1 = document.getElementById('step1__modal')
      //モーダルを表示
      modalStep1.style.display = 'block'
    },
    //googleMapの切り替え
    googleMap: function(index) {
      let maps = document.getElementsByClassName('googleMap')
      for (let i = 0; i < maps.length; i++) {
        maps[i].style.display = 'none'
      }
      let map = document.getElementById('map' + index)
      map.style.display = 'block'
    },
    hideMap: function() {
      let modalStep1 = document.getElementById('step1__modal')
      modalStep1.style.display = 'none'
    },
    bgColor: function(index) {
      const inputListDiv = document.getElementsByClassName('inputList__div')
      //inputの背景色変化！（クラスの付与）
      const inputList = document.getElementsByClassName('inputList')
      const shopName = document.getElementsByName('shopName')
      if (shopName[index].checked) {
        for (let i = 0; i < inputListDiv.length; i++) {
          inputList[i].classList.remove('bg_current')
        }
        inputList[index].classList.add('bg_current')
      }
    }
  }
}
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
  opacity: 0.7;
}
.googleMap {
  text-align: center;
  margin-top: 45px;
  margin-bottom: 30px;
  max-width: 100%;
  @media (max-width: 1199.98px) {
    height: 500px;
    position: relative;
    overflow: hidden;
    margin-bottom: 10px;
  }
  &::v-deep iframe {
    @media (max-width: 1199.98px) {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      top: 10px;
      height: 90% !important;
      width: 90% !important;
      max-width: 100%;
    }
  }
}
.btn {
  text-align: center;
  padding: 1px 0;
  background-color: #0d446f;
  color: #fff;
  border-radius: 25px;
  @media (max-width: 767.98px) {
  }
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  i {
    margin-right: 3px;
  }
}
.inputList {
  border-bottom: 1px solid #000;
  width: 80%;
  margin: auto;
  display: flex;
  align-items: center;
  padding: 10px;
  padding-bottom: 5px;
  background: #fff;
  @media (max-width: 767.98px) {
    width: 100%;
  }
  &.bg_current {
    background: #f5f5f5;
  }
  .div {
    width: 70%;
    display: flex;
    align-items: center;
  }
  input {
    /*      width: 5%;*/
    margin-top: 5px;
    /*      display: flex;*/
    /*      align-items: center;*/
    border: solid 1px #cccccc;
    color: #0d446f;
    display: inline-block;
    @media (max-width: 767.98px) {
      margin-top: 9px;
    }
  }
  label {
    width: 100%;
    text-align: left;
    padding-left: 10px;
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
    @media (max-width: 767.98px) {
      /*        width: 60%;*/
    }
    .span1 {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.64;
      text-align: center;
      color: #333333;
      @media (max-width: 767.98px) {
        font-weight: 500;
        line-height: 1.64;
        text-align: left;
        color: #333333;
      }
    }
    .span2 {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.92;
      text-align: left;
      color: #333333;
      @media (max-width: 767.98px) {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.92;
        text-align: left;
        color: #333333;
      }
    }
  }
  button {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    text-align: center;
    color: #ffffff;
    /*      margin-top: 10px;*/
    margin-bottom: 10px;
    padding: 8px 15px;
    width: 30%;
    @media (max-width: 767.98px) {
      margin: auto;
      padding: 8px 5px;
      font-size: 12px;
    }
  }
}
.step1__modal {
  display: none;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: -100px;
  z-index: 10;
  &--white {
    background: #fff;
    position: absolute;
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    width: 60%;
    margin: auto;
    z-index: 20;
    @media (max-width: 767.98px) {
      width: 90%;
      top: 50px;
      /*        height: 500px;*/
    }
    &Map {
      margin-top: 30px;
      text-align: center;
      margin-bottom: 30px;
      @media (max-width: 767.98px) {
        margin-top: 60px;
      }
      iframe {
        @media (max-width: 767.98px) {
          max-width: 90%;
        }
      }
    }
  }
  .stopButton {
    position: absolute;
    top: 0px;
    right: 15px;
    margin-top: 0;
    font-size: 40px;
    z-index: 100;
    @media (max-width: 767.98px) {
      top: 0px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}

// シティプラザ　休業のお知らせ
.city_plaza_rest_info {
  color: red;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 1rem;
}

// スマートショップとは？
.about-smartshop-container {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: flex-end;

  .about-smartshop-text {
    position: relative;
    opacity: 1;
    margin-bottom: 1rem;
    color: #aa9543;

    & > span {
      text-decoration: underline;
      padding-left: 0.2rem;
      line-height: 1;
    }

    &:hover {
      color: #aa9543;
      opacity: 0.7;
      text-decoration: none;
    }

    &::before {
      content: '\f059';
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
    }
  }

  @media (max-width: 767.98px) {
    width: 100%;
  }
}

.smartshop-badge {
  display: inline-block;
  background-color: #aa9543;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.58;
  text-align: center;
  padding: 5px 12px;
  margin-left: 10px;
}
</style>
